import { useLogin } from './useLogin';
import { useGoogleLogin } from './useGoogleLogin';
import { useLogout } from './useLogout';
import { useAuthStoreSelectors } from './useAuthStoreSelectors';
import type { RoleName, User } from '../types/auth.types';

export type UseAuthReturn = {
  user: User | null;
  isAuthenticated: boolean;
  isSuperAdmin: boolean;
  isCompanyAdmin: boolean;
  isAgent: boolean;
  isManager: boolean;
  isCompanyScoped: boolean;
  hasRole: (role: RoleName) => boolean;
  activeRole: RoleName | null;
  setActiveRole: (role: RoleName) => void;
  getAvailableRoles: () => RoleName[];
  login: ReturnType<typeof useLogin>['login'];
  googleLogin: ReturnType<typeof useGoogleLogin>['googleLogin'];
  logout: ReturnType<typeof useLogout>['logout'];
  isLoading: boolean;
  error: Error | null | undefined;
};

export function useAuth(): UseAuthReturn {
  const storeData = useAuthStoreSelectors();
  const { login, isLoading: isLoginLoading, error: loginError } = useLogin();
  const { googleLogin, isLoading: isGoogleLoading, error: googleError } = useGoogleLogin();
  const { logout, isLoading: isLogoutLoading } = useLogout();

  return {
    ...storeData,
    hasRole: (role: RoleName): boolean => storeData.hasRoleFn(role),
    login,
    googleLogin,
    logout,
    isLoading: isLoginLoading || isGoogleLoading || isLogoutLoading,
    error: loginError || googleError,
  };
}
